export default __webpack_public_path__ + "static/media/IMG_1290.410534d6.JPG";